import React, { Fragment, useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Button, Form, Modal } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import FilePreview from "../Common/FilePreview";
import swal from "sweetalert";
import SignatureCanvas from "react-signature-canvas";
import { useSearchParams } from "react-router-dom";

const getDeliveryItemKey = (item, index) => {
  if (item && item._id) return String(item._id);
  return `item_${index}`;
};

const MIRAdd = () => {
 const navigate = useNavigate();
 const [loading, setLoading] = useState(false);
 const sigPadRef = useRef(null);
 const [showSignModal, setShowSignModal] = useState(false);
 const [signatureFile, setSignatureFile] = useState(null);
const [searchParams] = useSearchParams();
const workOrderFromUrl = searchParams.get("workOrder");
const projectFromUrl = searchParams.get("project");


 const [workOrders, setWorkOrders] = useState([]);

  const filteredWorkOrders = useMemo(() => {
    if (!projectFromUrl) return workOrders;
    return workOrders.filter((wo) => {
      const pid = wo.project?._id || wo.project;
      return String(pid) === String(projectFromUrl);
    });
  }, [workOrders, projectFromUrl]);

 const [deliveries, setDeliveries] = useState([]);
 const [filteredDeliveries, setFilteredDeliveries] = useState([]);
 const [deliveryItems, setDeliveryItems] = useState([]);

 const [form, setForm] = useState({
 mirNumber: "",
 workOrder: "",
 deliveryReference: "",
 items: [
      {
        deliveryItemId: "",
        materialName: "",
        quantityInspected: "",
        unit: "",
        maxDelivered: 0,
        remark: "",
        isNonBillable: false,
      },
    ],
 inspectionReport: null,
 inspectionDate: new Date().toISOString().split("T")[0],
 approvalStatus: "Pending",
 clientApproval: null,
 remarks: "",
 });


useEffect(() => {
 fetchWorkOrders();
 fetchDeliveries();

 if (workOrderFromUrl) {
 setForm((prev) => ({
 ...prev,
 workOrder: workOrderFromUrl,
 }));
 }
}, [workOrderFromUrl, projectFromUrl]);

 

 const fetchWorkOrders = async () => {
 try {
 const res = await api.get("/work-orders?limit=1000");
 if (res.data.success) setWorkOrders(res.data.data);
 } catch {
 swal("Error", "Failed to load projects", "error");
 }
 };
 const clearSignature = () => {
 sigPadRef.current.clear();
 setSignatureFile(null);
 };

 const saveSignature = () => {
 if (sigPadRef.current.isEmpty()) {
 return swal("Error", "Please sign before saving", "error");
 }

 const dataURL = sigPadRef.current.toDataURL("image/png");
 const blob = dataURLtoBlob(dataURL);

 const file = new File([blob], "mir-signature.png", {
 type: "image/png",
 });

 setSignatureFile(file);
 setShowSignModal(false);
 swal("Success", "Signature saved", "success");
 };

 const dataURLtoBlob = (dataURL) => {
 const arr = dataURL.split(",");
 const mime = arr[0].match(/:(.*?);/)[1];
 const bstr = atob(arr[1]);
 let n = bstr.length;
 const u8arr = new Uint8Array(n);
 while (n--) u8arr[n] = bstr.charCodeAt(n);
 return new Blob([u8arr], { type: mime });
 };

 const fetchDeliveries = async () => {
 try {
 const res = await api.get("/deliveries?limit=1000");
 if (res.data.success) {
 setDeliveries(res.data.data);

 if (workOrderFromUrl) {
 const filtered = res.data.data.filter((d) => {
 const woId = d.workOrder?._id || d.workOrder;
 return String(woId) === String(workOrderFromUrl);
});

 setFilteredDeliveries(filtered);
} else {
 setFilteredDeliveries(res.data.data);
}
 }
 } catch {
 swal("Error", "Failed to load deliveries", "error");
 }
};
 // ------------------------- FORM CHANGE -------------------------
 const handleChange = (e) => {
 const { name, value } = e.target;

 // Work Order selected → filter deliveries
 if (name === "workOrder") {
 const filtered = deliveries.filter((d) => {
 const woId = d.workOrder?._id || d.workOrder;
 return String(woId) === String(value);
});

 setFilteredDeliveries(filtered);
 setDeliveryItems([]);

 setForm((p) => ({
 ...p,
 workOrder: value,
 deliveryReference: "",
 items: [
          {
            deliveryItemId: "",
            materialName: "",
            quantityInspected: "",
            unit: "",
            maxDelivered: 0,
            remark: "",
            isNonBillable: false,
          },
        ],
 }));
 return;
 }

 // Delivery selected → load items of delivery
 if (name === "deliveryReference") {
 const selected = deliveries.find((d) => d._id === value);
 setDeliveryItems(selected?.items || []);
 setForm((p) => ({
 ...p,
 deliveryReference: value,
 items: [
          {
            deliveryItemId: "",
            materialName: "",
            quantityInspected: "",
            unit: "",
            maxDelivered: 0,
            remark: "",
            isNonBillable: false,
          },
        ],
 }));
 return;
 }

 setForm((prev) => ({ ...prev, [name]: value }));
 };

 // ------------------------- ITEM CHANGE -------------------------
  const handleSubItemChange = (itemIndex, subIndex, field, value) => {
    const updated = [...form.items];
    const currentItem = { ...updated[itemIndex] };
    const subItems = [...(currentItem.subItems || [])];
    let finalValue = value;

    if (field === "quantityInspected" && finalValue !== "") {
      const numVal = parseFloat(finalValue);
      const maxVal = parseFloat(subItems[subIndex]?.quantityDelivered || subItems[subIndex]?.quantity || 0);
      if (!isNaN(numVal) && !isNaN(maxVal) && numVal > maxVal) {
        finalValue = maxVal;
      }
    }

    const updatedSub = {
      ...subItems[subIndex],
      [field]: finalValue,
    };

    subItems[subIndex] = updatedSub;
    currentItem.subItems = subItems;

    // Pro-rata parent quantityInspected from sub-items
    const totalSubDelivered = subItems.reduce(
      (sum, s) => sum + (parseFloat(s.quantityDelivered || s.quantity) || 0),
      0
    );
    const currentTotalInspected = subItems.reduce(
      (sum, s) => sum + (parseFloat(s.quantityInspected) || 0),
      0
    );
    const parentDeliveredQty = parseFloat(currentItem.maxDelivered || currentItem.quantityDelivered) || 0;

    if (parentDeliveredQty > 0 && totalSubDelivered > 0) {
      const newParentInspected = currentTotalInspected === 0
        ? 0
        : parseFloat(((currentTotalInspected / totalSubDelivered) * parentDeliveredQty).toFixed(4));
      currentItem.quantityInspected = newParentInspected;
    }

    updated[itemIndex] = currentItem;
    setForm((prev) => ({ ...prev, items: updated }));
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...form.items];

    // When selecting a material
    if (field === "deliveryItemId") {
      const item = deliveryItems.find(
        (i, idx) => getDeliveryItemKey(i, idx) === value
      );

      if (item) {
        updated[index] = {
          deliveryItemId: value,
          materialName: item.itemName,
          quantityInspected: item.quantityDelivered,
          unit: item.unit, // unit auto-set
          maxDelivered: item.quantityDelivered,
          remark: item.remark || "",
          isNonBillable: item.isNonBillable || false,
          subItems: (item.subItems || []).map((s) => ({
            name: s.name || "",
            quantityDelivered: s.quantityDelivered !== undefined ? s.quantityDelivered : (s.quantity || 0),
            quantityInspected: s.quantityInspected !== undefined ? s.quantityInspected : (s.quantityDelivered !== undefined ? s.quantityDelivered : (s.quantity || 0)),
            unit: s.unit || item.unit || "",
            remarks: s.remarks || "",
          })),
        };
      } else {
        updated[index] = {
          deliveryItemId: "",
          materialName: "",
          quantityInspected: "",
          unit: "",
          maxDelivered: 0,
            remark: "",
            isNonBillable: false,
        };
      }
    }

    // Validate quantity
    if (field === "remark") {
      updated[index].remark = value;
    }

    if (field === "quantityInspected") {
      const max = updated[index].maxDelivered || 0;
      if (Number(value) > Number(max)) {
        swal(
          "Warning",
          `Inspected qty cannot exceed delivered (${max})`,
          "warning",
        );
        return;
      }
      updated[index].quantityInspected = value;
    }

    setForm((prev) => ({ ...prev, items: updated }));
  };

 const addItem = () => {
    if (!form.deliveryReference) {
      swal("Warning", "Select a delivery first", "warning");
      return;
    }
    setForm((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          deliveryItemId: "",
          materialName: "",
          quantityInspected: "",
          unit: "",
          maxDelivered: 0,
            remark: "",
            isNonBillable: false,
        },
      ],
    }));
  };

  const removeItem = (index) => {
 if (form.items.length === 1) {
 swal("Warning", "At least one material is required", "warning");
 return;
 }
 setForm((prev) => ({
 ...prev,
 items: prev.items.filter((_, i) => i !== index),
 }));
 };

 // ------------------------- FILE UPLOAD (with size validation) -------------------------
 const handleFile = (e, field) => {
 const file = e.target.files[0];
 if (!file) return;

 const MAX_SIZE = 20 * 1024 * 1024; // 20MB
 if (file.size > MAX_SIZE) {
 swal("Warning", "File size must be less than 20MB", "warning");
 return;
 }

 setForm((prev) => ({
 ...prev,
 [field]: file, // store FILE directly
 }));
 };

 // ------------------------- SUBMIT -------------------------
 const handleSubmit = async (e) => {
 e.preventDefault();

 if (!form.workOrder) return swal("Warning", "Select work order", "warning");

 if (!form.deliveryReference)
 return swal("Warning", "Select delivery", "warning");

 for (const it of form.items) {
 if (!it.materialName)
 return swal("Warning", "Select material name", "warning");
 if (!it.quantityInspected)
 return swal("Warning", "Enter inspected quantity", "warning");
 }

 if (!form.inspectionReport)
 return swal("Warning", "Upload inspection report", "warning");

 try {
 setLoading(true);

 const formData = new FormData();

 // ---------------- BASIC FIELDS ----------------
 formData.append("workOrder", form.workOrder);

 formData.append("deliveryReference", form.deliveryReference);
 formData.append("inspectionDate", form.inspectionDate);
 formData.append("approvalStatus", form.approvalStatus);
 formData.append("remarks", form.remarks || "");
 if (signatureFile) {
 formData.append("signature", signatureFile);
 }

 // ---------------- ITEMS (ARRAY) ----------------
      form.items.forEach((item, index) => {
        if (item.deliveryItemId) {
          formData.append(`items[${index}][deliveryItemId]`, item.deliveryItemId);
        }
        formData.append(`items[${index}][materialName]`, item.materialName);
        formData.append(
          `items[${index}][quantityInspected]`,
          item.quantityInspected,
        );
        formData.append(`items[${index}][unit]`, item.unit);
        formData.append(`items[${index}][remark]`, item.remark || "");
        formData.append(`items[${index}][maxDelivered]`, item.maxDelivered);
        if (item.isNonBillable !== undefined) {
          formData.append(`items[${index}][isNonBillable]`, item.isNonBillable);
        }
      });

 // ---------------- FILES ----------------
 formData.append("inspectionReport", form.inspectionReport);

 if (form.clientApproval) {
 formData.append("clientApproval", form.clientApproval);
 }

 const res = await api.post("/mir", formData, {
 headers: {
 "Content-Type": "multipart/form-data",
 },
 });

 if (res.data.success) {
 swal("Success", "MIR created successfully!", "success");

 const backUrl =
 projectFromUrl || workOrderFromUrl
 ? `/mir?${projectFromUrl ? `project=${projectFromUrl}&` : ""}${
 workOrderFromUrl ? `workOrder=${workOrderFromUrl}` : ""
 }`
 : "/mir";

 navigate(backUrl);
}
 } catch (error) {
 swal(
 "Error",
 error.response?.data?.message || "Failed to create MIR",
 "error",
 );
 } finally {
 setLoading(false);
 }
 };

 // ------------------------- UI -------------------------
 return (
 <Fragment>
 <PageTitle activeMenu="Add MIR" motherMenu="Quality" />

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between">
 <Card.Title>Add Material Inspection Report</Card.Title>
 <Button
 variant="secondary"
 onClick={() =>
 navigate(
 workOrderFromUrl
 ? `/mir?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/mir"
 )
 }
>
 <i className="fas fa-arrow-left me-2"></i>Back
</Button>
 </Card.Header>

 <Card.Body>
 <Form onSubmit={handleSubmit} encType="multipart/form-data">
 {/* MIR Number & Date */}
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>MIR Number *</Form.Label>
 <Form.Control
 type="text"
 name="mirNumber"
 value="Auto-generated"
 disabled
 readOnly
/>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group>
 <Form.Label>Inspection Date *</Form.Label>
 <Form.Control
 type="date"
 name="inspectionDate"
 value={form.inspectionDate}
 onChange={handleChange}
 required
 />
 </Form.Group>
 </Col>
 </Row>

 {/* Project & Delivery */}
 <Row>
 <Col md={6}>
 <Form.Group>
 <Form.Label>Work Order *</Form.Label>
 <Form.Select
 name="workOrder"
 value={form.workOrder}
 onChange={handleChange}
>
 <option value="">Select Work Order</option>
 {filteredWorkOrders.map((wo) => (
 <option key={wo._id} value={wo._id}>
 {wo.woNo}{wo.label ? ` – ${wo.label}` : ""}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group>
 <Form.Label>Delivery Reference *</Form.Label>
 <Form.Select
 name="deliveryReference"
 value={form.deliveryReference}
 onChange={handleChange}
 >
 <option value="">Select Delivery</option>
 {filteredDeliveries.map((d) => (
 <option key={d._id} value={d._id}>
 {d.deliveryNumber} - {d.challanNumber}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>

 {/* MULTIPLE MATERIAL ITEMS */}
 <div className="mt-4">
 <h5 className="mb-3">Materials</h5>

 {form.items.map((item, index) => {
              // FILTER MATERIALS TO AVOID DUPLICATES (by deliveryItemId / unique key)
              const selectedOtherKeys = new Set(
                form.items
                  .filter((_, idx) => idx !== index)
                  .map((it) => it.deliveryItemId)
                  .filter(Boolean)
              );

              const availableOptions = deliveryItems
                .map((di, originalIdx) => ({
                  di,
                  key: getDeliveryItemKey(di, originalIdx),
                }))
                .filter(({ key }) => !selectedOtherKeys.has(key));

              return (
                <Card key={index} className="mb-3 p-3 border">
                  <div className="d-flex justify-content-between">
                    <h6>Item {index + 1}</h6>
                    {form.items.length > 1 && (
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => removeItem(index)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    )}
                  </div>

                  <Row className="mt-3">
                    <Col md={5}>
                      <Form.Group>
                        <Form.Label className="d-flex justify-content-between">
                          <span>Material *</span>
                          {item.isNonBillable && (
                            <span
                              className="badge badge-warning py-1 px-2"
                              style={{ fontSize: "10px" }}
                            >
                              Non-Billable
                            </span>
                          )}
                        </Form.Label>
                        <Form.Select
                          value={item.deliveryItemId || ""}
                          onChange={(e) =>
                            handleItemChange(
                              index,
                              "deliveryItemId",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">Select Item</option>

                          {availableOptions.map(({ di, key }) => (
                            <option key={key} value={key}>
                              {di.itemName} (Delivered: {di.quantityDelivered}{di.unit ? ` ${di.unit}` : ""}{di.poNumber ? ` | PO: ${di.poNumber}` : ""}{di.remark ? ` | ${di.remark}` : ""})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={2}>
                      <Form.Group>
                        <Form.Label>Quantity Inspected *</Form.Label>
                        <Form.Control
                          type="number"
                          value={item.quantityInspected}
                          onChange={(e) =>
                            handleItemChange(
                              index,
                              "quantityInspected",
                              e.target.value,
                            )
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={2}>
                      <Form.Group>
                        <Form.Label>Unit *</Form.Label>
                        {/* UNIT LOCKED — UNEDITABLE */}
                        <Form.Control
                          type="text"
                          value={item.unit}
                          disabled
                          readOnly
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Item Remark</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Remark"
                          value={item.remark || ""}
                          onChange={(e) =>
                            handleItemChange(
                              index,
                              "remark",
                              e.target.value,
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {item.subItems && item.subItems.length > 0 && (
                    <div className="mt-3 p-2 bg-light rounded border">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-primary fw-bold">
                          <i className="fa fa-list-ul me-1"></i> Sub-Items Breakdown (Enter inspected quantity for sub-items):
                        </small>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-sm table-bordered bg-white mb-0" style={{ fontSize: "0.82rem" }}>
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: "35%" }}>Sub-Item Name</th>
                              <th style={{ width: "15%" }} className="text-center">Delivered Qty</th>
                              <th style={{ width: "20%" }} className="text-center">Inspected Qty <span className="text-danger">*</span></th>
                              <th style={{ width: "15%" }} className="text-center">UOM</th>
                              <th style={{ width: "15%" }}>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.subItems.map((sub, sIdx) => (
                              <tr key={sIdx}>
                                <td className="align-middle"><strong>{sub.name}</strong></td>
                                <td className="align-middle text-center font-w600 text-muted">{sub.quantityDelivered !== undefined ? sub.quantityDelivered : sub.quantity}</td>
                                <td className="align-middle">
                                  <Form.Control
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max={sub.quantityDelivered !== undefined ? sub.quantityDelivered : sub.quantity}
                                    size="sm"
                                    placeholder="0.00"
                                    value={sub.quantityInspected !== undefined ? sub.quantityInspected : (sub.quantityDelivered !== undefined ? sub.quantityDelivered : (sub.quantity ?? ""))}
                                    onChange={(e) => handleSubItemChange(index, sIdx, "quantityInspected", e.target.value)}
                                    style={{ fontSize: "0.82rem" }}
                                    required
                                  />
                                </td>
                                <td className="align-middle text-center">
                                  <span className="badge bg-light text-dark border px-2 py-1">
                                    {sub.unit || item.unit || "—"}
                                  </span>
                                </td>
                                <td className="align-middle text-muted">{sub.remarks || "—"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
</Card>
 );
 })}

 <Button variant="success" size="sm" onClick={addItem}>
 <i className="fas fa-plus me-1"></i>Add Material
 </Button>
 </div>

 {/* Documents */}
 <div className="mt-4">
 <h5>Documents</h5>

 <Row>
 <Col md={6}>
 <Form.Group>
 <Form.Label>Inspection Report *</Form.Label>
 <Form.Control
 type="file"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={(e) => handleFile(e, "inspectionReport")}
 />
 <FilePreview 
 file={form.inspectionReport} 
 onRemove={() => setForm(prev => ({ ...prev, inspectionReport: null }))} 
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group>
 <Form.Label>Client Approval (Optional)</Form.Label>
 <Form.Control
 type="file"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={(e) => handleFile(e, "clientApproval")}
 />
 <FilePreview 
 file={form.clientApproval} 
 onRemove={() => setForm(prev => ({ ...prev, clientApproval: null }))} 
 />
 </Form.Group>
 </Col>
 </Row>
 </div>

 {/* Remarks */}
 <Form.Group className="mt-3">
 <Form.Label>Remarks</Form.Label>
 <Form.Control
 as="textarea"
 rows={3}
 name="remarks"
 value={form.remarks}
 onChange={handleChange}
 />
 </Form.Group>
 <button
 type="button"
 className="btn btn-warning me-2"
 onClick={() => setShowSignModal(true)}
 >
 Add Signature (Optional)
 </button>

 {signatureFile && (
 <span className="text-success ms-2"> Signed</span>
 )}

 {/* Buttons */}
 <div className="d-flex gap-2 mt-3">
 <Button type="submit" variant="primary" disabled={loading}>
 {loading ? "Creating..." : "Create MIR"}
 </Button>

 <Button
 type="button"
 variant="danger"
 onClick={() =>
 navigate(
 workOrderFromUrl
 ? `/mir?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/mir"
 )
 }
>
 Cancel
</Button>
 </div>
 </Form>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 <Modal
 show={showSignModal}
 onHide={() => setShowSignModal(false)}
 centered
 >
 <Modal.Header closeButton>
 <Modal.Title>Sign MIR</Modal.Title>
 </Modal.Header>

 <Modal.Body>
 <div
 style={{
 width: "100%",
 maxWidth: "600px",
 height: "200px",
 border: "2px dashed #999",
 margin: "0 auto",
 }}
 >
 <SignatureCanvas
 ref={sigPadRef}
 penColor="black"
 canvasProps={{
 width: 600,
 height: 200,
 style: { width: "100%", height: "200px" },
 }}
 />
 </div>
 </Modal.Body>

 <Modal.Footer>
 <Button variant="secondary" onClick={clearSignature}>
 Clear
 </Button>
 <Button variant="success" onClick={saveSignature}>
 Save Signature
 </Button>
 </Modal.Footer>
 </Modal>
 </Fragment>
 );
};

export default MIRAdd;
